import { render, staticRenderFns } from "./Smtpd.vue?vue&type=template&id=4e07c2c9&scoped=true&"
import script from "./Smtpd.vue?vue&type=script&lang=js&"
export * from "./Smtpd.vue?vue&type=script&lang=js&"
import style0 from "./Smtpd.vue?vue&type=style&index=0&id=4e07c2c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07c2c9",
  null
  
)

export default component.exports